/* import __COLOCATED_TEMPLATE__ from './answer-terminal.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, set } from '@ember/object';

export default class AnswerTerminal extends Component {
  @service appService;
  @service intl;

  get app() {
    return this.appService.app;
  }

  get inserters() {
    let inserters = [
      {
        name: 'emoji',
        icon: 'lwr-happy',
        descriptor: this.intl.t(
          'operator.workflows.visual-builder.chat-message-inserter.add-emoji',
        ),
        hasPopoverContentComponent: true,
      },
    ];

    if (!this.app.canUseStandalone) {
      inserters.push({
        name: 'article',
        icon: 'article',
        descriptor: this.intl.t(
          'operator.workflows.visual-builder.chat-message-inserter.add-article',
        ),
        hasPopoverContentComponent: true,
      });
    }
    if (this.app.teammateConversationGifsEnabled) {
      inserters.insertAt(1, {
        name: 'gif',
        icon: 'gif',
        descriptor: this.intl.t('operator.workflows.visual-builder.chat-message-inserter.add-gif'),
        hasPopoverContentComponent: true,
      });
    }
    if (this.app.teammateConversationAttachmentsEnabled) {
      inserters.push({
        name: 'image',
        icon: 'picture',
        descriptor: this.intl.t(
          'operator.workflows.visual-builder.chat-message-inserter.add-image',
        ),
        hasPopoverContentComponent: false,
      });
      inserters.push({
        name: 'attachment',
        icon: 'attachment',
        descriptor: this.intl.t(
          'operator.workflows.visual-builder.chat-message-inserter.add-attachment',
        ),
        hasPopoverContentComponent: false,
      });
    }

    if (this.args.enabledInserterNames) {
      inserters = inserters.filter((inserter) =>
        this.args.enabledInserterNames.includes(inserter.name),
      );
    }

    return inserters;
  }

  get icon() {
    if (this.showTerminalStepV2) {
      switch (this.args.step.endingType) {
        case 'pass_to_team':
          return 'assignment';
        case 'finish_answer':
          return 'fin';
        default:
          return 'fin';
      }
    } else {
      switch (this.args.step.endingType) {
        case 'pass_to_team':
          return 'multiple-people';
        case 'show_standard_replies':
          return 'fin';
        case 'resolve':
          return 'rounded-check';
        case 'send_ticket':
          return 'ticket';
        case 'finish_answer':
          return 'fin';
        default:
          return 'fin';
      }
    }
  }

  get shouldShowError() {
    return this.args.editorState.shouldShowValidations && !this.args.step.validations.isValid;
  }

  get showTerminalStepV2() {
    return this.app.canUseFinTerminalStepV2 && this.args.step.blocks.length > 0;
  }

  get terminalActions() {
    return [
      {
        text: this.intl.t('operator.workflows.visual-builder.finish-answer-terminal-dropdown'),
        description: this.intl.t(
          'operator.workflows.visual-builder.finish-answer-terminal-dropdown-description',
        ),
        icon: 'fin',
        value: 'finish_answer',
      },
      {
        text: this.intl.t('operator.workflows.visual-builder.pass-to-team-v2'),
        description: this.intl.t('operator.workflows.visual-builder.pass-to-team-v2-description'),
        icon: 'assignment',
        value: 'pass_to_team',
      },
    ];
  }

  @action
  onSelectAction(action) {
    set(this.args.step, 'endingType', action);
  }
}
